<template>
  <div>
    <b-button
      style="margin-bottom: 10px;"
      variant="primary"
      @click="allPechat"
      class="navbarBtnTashxis"
    >
      <b-icon icon="printer-fill"></b-icon>
      Печать
    </b-button>
    <b-button
      variant="primary"
      class="navbarBtnTashxis mb-2 mr-2 ml-2"
      v-b-modal="'modal-shablon' + 'bayonnoma' + modalIdCom"
      @click="getShablonDoctor('bayonnoma', { type: false })"
    >
      <b-icon icon="arrow-down-circle-fill"></b-icon>
    </b-button>

    <b-button
      variant="primary"
      class="navbarBtnTashxis mb-2"
      @click="(status = 'bayonnoma'), (row_click_type = { type: false })"
      v-b-modal="'modal-new-shab-creat-bayonnoma' + modalIdCom"
    >
      <b-icon icon="arrow-up-circle-fill"></b-icon>
    </b-button>
    <b-modal
      :id="'modal-shablon' + 'bayonnoma' + modalIdCom"
      size="lg"
      :title="$t('Шаблонлар рўйхати')"
      hide-footer
    >
      <Shablon
        :modalIdCom="modalIdCom"
        :plus_dont_show="true"
        :shabType="'bayonnoma'"
        :itemsShablon="itemsShablon"
        @ShablonGet="getShablon"
        @RowClickedShab="RowClickedShab"
      />
    </b-modal>
    <b-modal
      :id="'modal-new-shab-creat-bayonnoma' + modalIdCom"
      :title="$t('Шифокор шаблон')"
      hide-footer
    >
      <div>
        <div>
          <b-input type="text" v-model="name"></b-input>
        </div>
      </div>
      <div class="CreateName">
        <b-button
          class="modalBtn1"
          size="sm"
          style="height: 37px;"
          variant="danger "
          @click="ShifokorShablonClose"
        >
          <b-icon icon="calendar2-x"></b-icon>
          {{ $t("Бекор қилиш") }}
        </b-button>
        <b-button
          class="mt-3 ml-2 modalBtn"
          @click="ShifokorShablon"
          variant="success"
        >
          <b-icon icon="calendar2-plus"></b-icon>
          {{ $t("Сақлаш") }}
        </b-button>
      </div>
    </b-modal>
    <div
      style="font-size: 35px; font-weight: 600; text-align: center; font-family: 'Times New Roman';"
    >
      BEMORNING TIBBIY BAYONNOMASI №
      <input
        type="number"
        class="input-stile"
        style="font-size: 35px; font-weight: 600; width: 170px; margin-bottom: 5px;"
        @input="changeHistoryId"
        v-model="historyId"
      />
    </div>
    <div style="display: flex; justify-content: space-between;">
      <div class="stat-bemor-text">
        <div class="display-flex">
          <label>Shifoxonaga yotqizilgan kun:</label>
          <input
            v-model="selectShablonJson.value1"
            class="input-stile"
            type="date"
            @input="textChange"
          />
        </div>
        <div class="display-flex">
          <label>Shifoxonadan chiqarilgan kun:</label>
          <input
            v-model="selectShablonJson.value2"
            class="input-stile"
            type="date"
            @input="textChange"
          />
        </div>
        <div>
          <input
            v-model="selectShablonJson.value3"
            class="input-stile"
            style="min-width: calc(100% - 450px);"
            @focus="showDiv($event, 'value3', 'value3')"
            @blur="handleBlur($event)"
            type="text"
            @input="textChange($event)"
          />
          <label>bo'lim, xona №</label>
          <input
            v-model="selectShablonJson.value4"
            class="input-stile"
            @blur="handleBlur($event)"
            @input="textChange($event)"
            @focus="showDiv($event, 'value4', 'value4')"
            type="text"
          />
        </div>
        <div>
          <label>Bo'limga</label>
          <input
            v-model="selectShablonJson.value5"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value5', 'value5')"
            @input="textChange($event)"
            class="input-stile"
            style="min-width: calc(100% - 550px);"
          />
          <label>o'tkazilgan</label>
          <input
            v-model="selectShablonJson.value6"
            @input="textChange($event)"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value6', 'value6')"
            class="input-stile"
            style="width: 70px;"
          />
          <label>kun yotib davolangan</label>
        </div>
        <div class="display-flex">
          <label>Bemorni olib yurish turlari:</label>
          <div
            @click="
              selectKey('value7'),
                (row_click_type = { type: true, value: 'value7' })
            "
            style="min-width: calc(100% - 250px);"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value7"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>Qon guruhi:</label>
          <input
            v-model="selectShablonJson.value8"
            type="text"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value8', 'value8')"
            @input="textChange($event)"
            class="input-stile"
            style="width: 70px;"
          />
          <label>rezus mansubligi </label>
          <div
            @click="
              selectKey('value9'),
                (row_click_type = { type: true, value: 'value9' })
            "
            style="min-width: calc(100% - 350px); max-width: calc(100% - 750px);"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value9"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div>
          <label>Dorilarning nojo'ya ta'siri</label>
          <input
            v-model="selectShablonJson.value10"
            type="text"
            @blur="handleBlur($event)"
            @input="textChange($event)"
            @focus="showDiv($event, 'value10', 'value10')"
            class="input-stile"
            style="width: calc(100% - 210px);"
          />
        </div>
        <div>
          <label>1. F.I.O: {{ $store.state.bemor.fullname }}</label>
          <label>2. Jinsi: {{ $store.state.bemor.gender }}</label>
          <label
            >3. Tug'ilgan kuni:
            {{ $store.state.bemor.birthday | dateFormat }}</label
          >
          <br />
          <label>4. Bo'yi:</label>
          <input
            v-model="selectShablonJson.value11"
            class="input-stile"
            @blur="handleBlur($event)"
            @input="textChange($event)"
            @focus="showDiv($event, 'value11', 'value11')"
            style="width: 100px;"
            type="text"
          />
          <label>vazni</label>
          <input
            v-model="selectShablonJson.value12"
            @input="textChange($event)"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value12', 'value12')"
            style="width: 100px;"
            type="text"
            class="input-stile"
          />
          <label>tana harorati</label>
          <input
            v-model="selectShablonJson.value13"
            @input="textChange($event)"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value13', 'value13')"
            class="input-stile"
            type="text"
            style="width: 100px;"
          />
          <br />
          <label>
            5. Doimiy yashash joyi
            {{
              $store.state.bemor.region ? $store.state.bemor.region.name : ""
            }}
            {{
              $store.state.bemor.district
                ? $store.state.bemor.district.name
                : ""
            }}
            {{ $store.state.bemor.addres }}
          </label>
          <br />
          <label>6. Ish joyi, kasbi, lavozimi</label>
          <input
            v-model="selectShablonJson.value14"
            class="input-stile"
            @input="textChange($event)"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value14', 'value14')"
            type="text"
            style="width: calc(100% - 210px); margin-bottom: 5px;"
          />
        </div>
        <div class="display-flex">
          <label>7. Bemor qayerdan yuborilgan</label>
          <div
            @click="
              selectKey('value15'),
                (row_click_type = { type: true, value: 'value15' })
            "
            style="min-width: calc(100% - 260px);"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value15"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div class="display-flex">
          <label>8. Shifoxonaga shoshilinch ravishda keltirilgan:</label>
          <div
            @click="
              selectKey('value16'),
                (row_click_type = { type: true, value: 'value16' })
            "
            style="min-width: calc(100% - 400px);"
          >
            <v-select
              style="width: 100%;"
              :options="itemShablon"
              ref="doriselect"
              label="name"
              v-model="selectShablonJson.value16"
              @search="ValueSel"
              @input="textChange"
              :reduce="options => options.name"
              @keydown.native="setStatus($event)"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" v-bind="attributes" v-on="events" />
                <button
                  class="btn-select"
                  v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                >
                  ...
                </button>
              </template>
              <template
                v-slot:no-options="{
                  search,
                  searching
                }"
              >
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >{{ "бўйича маьлумот йўқ" }}
                  <div class="d-flex-center">
                    <b-button
                      class="insertbtn"
                      variant="success"
                      @click="setStatus(45)"
                      v-b-modal="'modal-shab-select-create' + modalIdCom"
                    >
                      <b-icon icon="plus" color="#fff"></b-icon>
                    </b-button>
                  </div>
                  <b> Insert</b>
                </template>
                <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
              </template>
            </v-select>
          </div>
        </div>
        <div style="margin-left: 20px;">
          <div class="display-flex">
            <label>Qanday transportda</label>
            <div
              @click="
                selectKey('value17'),
                  (row_click_type = { type: true, value: 'value17' })
              "
              style="min-width: calc(100% - 200px);"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value17"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    class="btn-select"
                    v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create' + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="display-flex">
            <label>Kasallik boshlangandan so'ng o'tgan vaqt</label>
            <div
              @click="
                selectKey('value18'),
                  (row_click_type = { type: true, value: 'value18' })
              "
              style="min-width: calc(100% - 340px);"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value18"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    class="btn-select"
                    v-b-modal="'shablon-select' + 'select-bay' + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create' + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div>
          <label>Bemor yo'llanmasidagi tashxis: </label>
          <input
            v-model="selectShablonJson.value19"
            @input="textChange($event)"
            @blur="handleBlur($event)"
            @focus="showDiv($event, 'value19', 'value19')"
            class="input-stile"
            type="text"
            style="min-width: calc(100% - 340px);"
          />
        </div>
      </div>
      <div class="stat-bemor-text">
        <label>Sana </label>
        <input
          type="datetime-local"
          class="input-stile"
          @input="textChange($event)"
          v-model="selectShablonJson.value21"
        />
        <h3 style="text-align: center; font-family: 'Times New Roman';">
          Qabulxona shifokorining yozuvi
        </h3>
        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3 mr-2"
          v-b-modal="'modal-shablon' + 'bayonnoma' + modalIdCom"
          @click="
            getShablonDoctor('qabulxonavalue20', {
              type: true,
              value: 'value20'
            })
          "
        >
          <b-icon icon="arrow-down-circle-fill"></b-icon>
        </b-button>

        <b-button
          variant="primary"
          class="navbarBtnTashxis mb-3"
          @click="
            (key = 'qabulxonavalue20'),
              (row_click_type = { type: true, value: 'value20' })
          "
          v-b-modal="'modal-new-shab-creat-bayonnoma' + modalIdCom"
        >
          <b-icon icon="arrow-up-circle-fill"></b-icon>
        </b-button>
        <textarea
          v-model="selectShablonJson.value20"
          @input="textChange($event)"
          style="width: 100%; height: 600px;"
        ></textarea>
      </div>
    </div>
    <b-modal
      :id="'shablon-select' + 'select-bay' + modalIdCom"
      size="xl"
      hide-footer
    >
      <div style="display: flex; justify-content: space-between;">
        <button
          class="navbarBtnTashxis mb-2"
          v-b-modal="'modal-shab-select-create' + modalIdCom"
          @click="plusClick"
        >
          <b-icon icon="plus-lg"></b-icon>
        </button>

        <b-form-group
          label-for="filterTekshiruvlar-input"
          label-cols-sm="1"
          label-align-sm="right"
          label-size="sm"
          class="mb-2 col-8"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterTekshiruvlar-input"
              v-model="filter"
              type="search"
              :placeholder="$t('Қидирув')"
            ></b-form-input>

            <b-input-group-append>
              <b-button
                :disabled="!filter"
                variant="danger"
                @click="filter = ''"
              >
                {{ $t("Тозалаш") }}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div>
        <b-table
          id="bemor-table"
          ref="refTable"
          hover
          sort-icon-left
          striped
          primary-key="id"
          :items="itemShablon"
          :fields="fields"
          :filter="filter"
          :current-page="currentPage"
          :filter-included-fields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @row-clicked="RowClickedShab($event, null, true)"
          stacked="md"
          show-empty
          small
          @filtered="onFiltered"
        >
          <template #cell(№)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(actions)="row">
            <b-row class="ml-1">
              <section
                style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
              >
                <div style="display: flex;">
                  <b-button
                    v-b-modal="'modal-shab-select-create' + modalIdCom"
                    variant="outline-primary"
                    @click="userLink(row.item)"
                    class="pencil"
                  >
                    <b-icon
                      style="width: 15px;"
                      variant="outline-primary"
                      icon="pencil-fill"
                      aria-hidden="true"
                    ></b-icon>
                  </b-button>
                  <div>
                    <b-button
                      class="trash ml-2"
                      style=""
                      variant="outline-danger"
                      @click="trash(row.item.id)"
                    >
                      <b-icon
                        style="width: 15px;"
                        icon="trash-fill"
                        aria-hidden="true"
                      ></b-icon>
                    </b-button>
                  </div>
                </div>
              </section>
            </b-row>
          </template>
        </b-table>
      </div>
    </b-modal>
    <b-modal
      :id="'modal-shab-select-create' + modalIdCom"
      :title="$t('Шифокор шаблон')"
      size="lg"
      hide-footer
    >
      <div>
        <b-input
          type="text"
          style="border: 1px solid #ccc; border-radius: 5px;"
          v-model="datas.name"
        >
        </b-input>
      </div>
      <div class="CreateName">
        <b-button
          class="modalBtn1"
          size="sm"
          style="height: 37px;"
          variant="danger "
          @click="Close()"
        >
          <b-icon icon="calendar2-x"></b-icon>
          {{ $t("Бекор қилиш") }}
        </b-button>
        <b-button
          class="mt-3 ml-2 modalBtn"
          @click="Shablon()"
          variant="success"
        >
          <b-icon icon="calendar2-plus"></b-icon>
          {{ $t("Сақлаш") }}
        </b-button>
      </div>
    </b-modal>
    <div
      :style="{
        top: divPosition.top + 'px',
        left: divPosition.left + 'px',
        width: divPosition.width + 'px',
        display: show ? 'block' : 'none'
      }"
      class="dynamic-div"
    >
      <div
        v-for="item in itemShablon"
        class="drop-down"
        @click="selectItemValue(item.name)"
      >
        {{ item.name }}
        <div class="display-flex">
          <b-button
            v-b-modal="'modal-shab-select-create' + modalIdCom"
            variant="outline-primary"
            style="width: 30px; height: 30px"
            @click="userLink(row.item)"
            class="pencil"
          >
            <b-icon
              style="width: 10px;"
              variant="outline-primary"
              icon="pencil-fill"
              aria-hidden="true"
            ></b-icon>
          </b-button>
          <b-button
            class="trash ml-2"
            style="width: 30px; height: 30px"
            variant="outline-danger"
            @click="trash(item.id)"
          >
            <b-icon
              style="width: 10px;"
              icon="trash-fill"
              aria-hidden="true"
            ></b-icon>
          </b-button>
        </div>
      </div>
      <b-button
        class="insertbtn"
        style="align-items: center; text-align: center"
        variant="success"
        @click="setStatus(45)"
        v-b-modal="'modal-shab-select-create' + modalIdCom"
      >
        <b-icon icon="plus" color="#fff"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Shablon from "../Shifokor/Shablon.vue";
export default {
  props: ["statsionar_text", "history_id", "modalIdCom"],
  components: {
    Shablon
  },
  data() {
    return {
      historyId: null,
      options: [],
      show: false,
      divPosition: {
        top: 0,
        left: 0,
        with: 0
      },
      datas: {
        id: 0,
        name: "",
        status: ""
      },
      localUser: JSON.parse(localStorage.getItem("user")),
      itemsShablon: [],
      name: "",
      selectShablonJson: {},
      itemShablon: [],
      status: "",
      row_click_type: {
        type: false,
        value: ""
      },
      key: null,
      ValueSelect: "",
      fields: [
        "№",
        { key: "name", label: "Номи", sortable: true },
        { key: "actions", label: "" }
      ],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: ["name"]
    };
  },
  filters: {
    dateFormat: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    }
  },
  created() {
    this.historyId = this.history_id;
    if (this.statsionar_text == "" || !this.statsionar_text) {
      this.selectShablonJson = {
        value1: null,
        value2: null,
        value3: null,
        value4: null,
        value5: null,
        value6: null,
        value7: null,
        value8: null,
        value9: null,
        value10: null,
        value11: null,
        value12: null,
        value13: null,
        value14: null,
        value15: null,
        value16: null,
        value17: null,
        value18: null,
        value19: null,
        value20: null,
        value21: null
      };
    } else {
      this.selectShablonJson = JSON.parse(this.statsionar_text.toString());
    }
  },
  watch: {
    history_id(newval) {
      this.historyId = newval;
    },
    statsionar_text(newVal, old) {
      this.selectShablonJson = JSON.parse(newVal.toString());
    }
  },
  methods: {
    allPechat() {
      let t = {};
      t = {
        doc_type: "default",
        bemor: this.$store.state.bemor,
        value: this.statsionar_text
      };
      localStorage.setItem("bayonnoma", JSON.stringify(t));
      const rout = this.$router.resolve({
        path: "/user-bayonnoma"
      });
      window.open(rout.href, "_blank");
    },
    selectItemValue(value) {
      if (this.selectShablonJson[`${this.status}`] == null) {
        this.selectShablonJson[`${this.status}`] = value;
      } else {
        this.selectShablonJson[`${this.status}`] += ` ${value}`;
      }
      this.show = false;
      this.textChange();
    },
    showDiv(event, key, status) {
      this.status = key;
      this.getShablon(status);
      const input = event.target;
      const rect = input.getBoundingClientRect();
      this.divPosition.top = rect.top + window.pageYOffset + rect.height - 365;
      this.divPosition.left = rect.left + window.pageXOffset - 20;
      // this.divPosition.top = rect.bottom + window.scrollY;
      // this.divPosition.left = rect.left + window.scrollX;
      this.divPosition.width = rect.width;
      setTimeout(() => {
        this.handleBlur("", true);
      }, 200);
    },
    handleBlur(event, type) {
      if (!type) {
        setTimeout(() => {
          this.show = false;
        }, 100);
      } else {
        this.show = true;
      }
    },
    ShifokorShablonClose() {
      this.name = "";
      this.$bvModal.hide(
        `${"modal-new-shab-creat-bayonnoma" + this.modalIdCom}`
      );
    },
    RowClickedShab($events, ind, type) { 
      if (this.row_click_type.type) {
        this.selectShablonJson[`${this.row_click_type.value}`] = type ? $events.name : $events.text;
      } else {
        let text = JSON.parse($events.text.toString());
        this.selectShablonJson = text;
      }
      this.textChange();
      this.$bvModal.hide(`${"modal-shablon" + "bayonnoma" + this.modalIdCom}`);
      this.$bvModal.hide("shablon-select" + "select" + this.modalIdCom);
    },
    getShablonDoctor(key, type) {
      let self = this;
      self.status = key;
      self.row_click_type = type;
      axios({
        method: "post",
        url: "/shablon_doctor/shablonOne",
        data: {
          doctor_id: 1,
          doc_type: key
        }
      }).then(res => {
        if (res) {
          self.itemsShablon = res.data.data;
        }
      });
    },
    ShifokorShablon() {
      let self = this;
      let text = "";
      if (self.row_click_type.type) {
        text = self.selectShablonJson[self.row_click_type.value];
      } else {
        text = JSON.stringify(self.selectShablonJson).toString();
      }
      axios({
        method: "post",
        url: "/shablon_doctor/create",
        data: {
          name: self.name,
          text: text,
          doctor_id: 1,
          doc_type: self.status ? self.status : "bayonnoma"
        }
      }).then(res => {
        if (res) {
          self.$bvModal.hide(
            `${"modal-new-shab-creat-bayonnoma" + self.modalIdCom}`
          );
        }
      });
    },
    changeHistoryId() {
      this.$emit("changeHistoryId", this.historyId);
    },
    textChange($event) {
      this.$emit(
        "statsionar_text_change",
        JSON.stringify(this.selectShablonJson).toString(),
        "bayonnoma"
      );

      // this.filteredShablon = this.itemsShablon.filter((item) => {
      //   let ok = false;
      //   if (item.name.trim().toLowerCase().includes($event.target.value.trim().toLowerCase())) {
      //     ok = true;
      //   }
      //   return ok;
      // })
    },
    plusClick() {
      this.datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    setStatus($events) {
      if ($events.keyCode == 45 || $events == 45) {
        this.datas = {
          name: this.ValueSelect,
          status: this.status
        };
        this.$bvModal.show("modal-shab-select-create" + this.modalIdCom);
      }
    },
    selectKey(key) {
      this.status = key;
      this.getShablon(key);
    },
    getShablon(status) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_select/shablonOne",
        data: { status: status }
      }).then(res => {
        if (res) {
          self.itemShablon = res.data.data;
        }
      });
    },
    userLink(item) {
      this.datas = item;
      this.$bvModal.show("modal-shab-select-create" + this.modalIdCom);
    },
    trash(id) {
      let self = this;
      axios({
        method: "delete",
        url: "/shablon_select/delete/" + id
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          // self.$bvModal.hide('modal-shab-select-create' + self.index + self.modalIdCom);
        }
      });
    },
    ValueSelChange() {
      let value = JSON.stringify(this.statsionar_text);
      // console.log(this.statsionar_text, value);
      this.$emit("selectSablon", value, this.index);
      // this.shablonData = JSON.stringify(this.statsionar_text)
    },
    ValueSel(e) {
      this.ValueSelect = e;
    },
    Shablon() {
      let self = this;
      let method = "";
      let url = "";
      if (this.datas.id) {
        method = "patch";
        url = "/shablon_select/update/" + self.datas.id;
      } else {
        self.datas.status = self.status;
        method = "post";
        url = "/shablon_select/create";
      }
      axios({
        method: method,
        url: url,
        data: self.datas
      }).then(res => {
        if (res) {
          self.getShablon(self.status);
          self.$bvModal.hide("modal-shab-select-create" + self.modalIdCom);
          self.datas = {
            id: 0,
            name: "",
            status: ""
          };
        }
      });
    },
    Close() {
      datas = {
        id: 0,
        name: "",
        status: ""
      };
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style lang="scss">
.pencil {
  width: 35px;
  height: 35px;
  display: flex;
  background: #fff;
  border: 1px solid #e9f1fa;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
}
.trash {
  background: #fff;
  width: 35px;
  height: 35px;
  display: flex;
  border: 1px solid #fff0f0;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.dynamic-div {
  min-width: 150px;
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 5;
  cursor: pointer;
  display: none;
  .drop-down {
    cursor: pointer;
    align-items: center;
    height: 35px;
    display: flex;
    justify-content: space-between;
    padding-left: 5px;
    font-size: 13pt;
  }
}
.drop-down:hover {
  background: rgb(46, 165, 255);
  color: #fff;
}

.stat-bemor-text {
  width: 49.5%;
  padding: 10px;
  border: 1px solid rgb(46, 165, 255);
  border-radius: 10px;
  label {
    font-family: "Times New Roman", Times, serif;
    margin-top: 5px;
    font-size: 13pt;
    font-weight: 500;
    margin-right: 5px;
  }
  textarea {
    font-family: "Times New Roman", Times, serif;
    font-size: 13pt;
    font-weight: 500;
  }
}
.input-stile {
  border-top: none;
  border-left: none;
  border-right: none;
  font-family: "Times New Roman", Times, serif;
  font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
  border-bottom: 1px solid #000;
}
.display-flex {
  display: flex;
}
.btn-select {
  background-color: #fff;
  border: none;
  // border: 1px  solid #000;
  // border-radius: 50%;
  font-size: 14pt;
  font-weight: 700;
  height: 27px;
  width: 27px;
  cursor: pointer;
  z-index: 2;
  position: absolute;
  top: 3px;
  right: 25px;
  color: #6c6868;
  /* left: -50px; */
}
</style>
